import { createAsyncThunk } from "@reduxjs/toolkit";
import { sendContactDataService } from "../../apiService/contact";

interface ContactData {
  name: string;
  email: string;
  phone_number: string;
  query: string;
}

export const sendContactData = createAsyncThunk(
  "vyga/sendContactData",
  async (contactData: ContactData, { rejectWithValue }) => {
    try {
      const result = await sendContactDataService(contactData);
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
